module.exports = __webpack_public_path__ + "static/img/dialog_bg.869e131.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/dialog_bg.png
// module id = aj67
// module chunks = 1